/* batida-addon-autofill.js — FIX Batida V.5.3.5 (2026-05-29).
   Makes the PERSONALIZACJA / DODATKI add-on rows fully automatic for ANY new
   no-variant product the e-store manager adds to a product's Cross sell list —
   no hardcoding, no metafield required.

   custom.js builds each add-on as a .batida-perso-row (title / price / toggle)
   and an ⓘ popup (custom.js openModal already fetches image + description for any
   handle). But for a brand-new add-on three things fall through:
     1. surcharge column blank (PRICE_OVERRIDES / Pipeline span don't cover it),
     2. subtitle blank (hardcoded SUBTITLES / __batidaAddonData don't cover it),
     3. ⓘ icon missing (moveViewProducts() removes the SVG fallback while trying
        to swap in Pipeline's .view_product, which it can't resolve for new add-ons).
   e.g. "Francuskie makaroniki" (zestaw-makaronikow) showed a bare toggle.

   This module post-fills all three from the add-on product's own data via
   /products/{handle}.js: surcharge from product price, subtitle from the first
   sentence of the description, and (if no icon) an ⓘ that opens the existing
   v67-styled popup with the product's image + description. Standalone + additive:
   it never overwrites a value custom.js already set. */
(function () {
  if (!document.querySelector('body.template-product')) return;

  var cache = {};
  function fmtPrice(cents) {
    if (cents == null || isNaN(cents)) return '';
    if (window.batidaMoney) return '+ ' + window.batidaMoney(cents);   /* 29.09: the site-wide price helper */
    return '+ ' + (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }
  function firstSentence(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    var txt = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
    if (!txt) return '';
    var s = txt.split('.')[0].trim();
    return s.length > 120 ? s.slice(0, 120) : s;
  }
  /* Short descriptor = custom.cross_sell_subtitle metafield (via the server-rendered
     window.__batidaAddonData) → else first sentence of the description. Used for BOTH
     the row subtitle and the popup. */
  function shortDescriptor(handle, p) {
    var ad = window.__batidaAddonData && window.__batidaAddonData[handle];
    if (ad) {
      var s = (ad.subtitle || ad.descFirstSentence || '').trim();
      if (s) return s;
    }
    return p ? firstSentence(p.description) : '';
  }
  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '.js';
    cache[handle] = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; });
    return cache[handle];
  }

  /* Reuse custom.js's modal if present (so v67 .batida-perso-modal styling applies);
     create an identical one otherwise. */
  function ensureModal() {
    /* Own modal id (custom.js owns #batida-perso-modal) — reuse the v67
       .batida-perso-modal* classes for identical styling, but isolate the
       instance so custom.js's openModal can't clobber our content. */
    var m = document.getElementById('batida-autofill-modal');
    if (m) return m;
    m = document.createElement('div');
    m.id = 'batida-autofill-modal';
    m.className = 'batida-perso-modal-backdrop';
    m.innerHTML =
      '<div class="batida-perso-modal" role="dialog" aria-modal="true">' +
        '<button type="button" class="batida-perso-modal__close" aria-label="Zamknij">×</button>' +
        '<img class="batida-perso-modal__image" alt="" />' +
        '<p class="batida-perso-modal__title"></p>' +
        '<p class="batida-perso-modal__price"></p>' +
        '<p class="batida-perso-modal__desc"></p>' +
      '</div>';
    document.body.appendChild(m);
    function close() { m.classList.remove('is-open'); }
    m.querySelector('.batida-perso-modal__close').addEventListener('click', close);
    m.addEventListener('click', function (e) { if (e.target === m) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.classList.contains('is-open')) close(); });
    return m;
  }
  function openPopup(p, priceText, descText) {
    var m = ensureModal();
    var img = m.querySelector('.batida-perso-modal__image');
    m.querySelector('.batida-perso-modal__title').textContent = p.title || '';
    m.querySelector('.batida-perso-modal__price').textContent = priceText || '';
    // Short descriptor only (metafield → first sentence), not the full description.
    m.querySelector('.batida-perso-modal__desc').textContent = descText || '';
    if (p.featured_image) { img.src = p.featured_image; img.alt = p.title || ''; img.style.display = ''; }
    else { img.removeAttribute('src'); img.style.display = 'none'; }
    m.classList.add('is-open');
  }

  function enrich() {
    var rows = document.querySelectorAll('.batida-perso-card .batida-perso-row[data-handle]');
    rows.forEach(function (row) {
      if (row.getAttribute('data-autofill') === '1') return;
      var handle = row.getAttribute('data-handle');
      if (!handle) return;
      var priceCol = row.querySelector('.batida-perso-price-col');
      var titleCol = row.querySelector('.batida-perso-title-col');
      var title = titleCol && titleCol.querySelector('.batida-perso-title');
      var needPrice = priceCol && !priceCol.textContent.trim();
      var needSubtitle = titleCol && !row.querySelector('.batida-perso-subtitle');
      var needIcon = title && !row.querySelector('.batida-perso-info, .view_product, .batida-autofill-info');
      if (!needPrice && !needSubtitle && !needIcon) { row.setAttribute('data-autofill', '1'); return; }
      row.setAttribute('data-autofill', '1'); // claim once; never re-fill a custom.js value
      fetchProduct(handle).then(function (p) {
        if (!p) return;
        if (needPrice && !priceCol.textContent.trim()) {
          var pr = fmtPrice(p.price);
          if (pr) priceCol.textContent = pr;
        }
        if (needSubtitle && !row.querySelector('.batida-perso-subtitle')) {
          var s = shortDescriptor(handle, p);
          if (s) {
            var el = document.createElement('p');
            el.className = 'batida-perso-subtitle';
            el.textContent = s;
            if (title && title.nextSibling) titleCol.insertBefore(el, title.nextSibling);
            else titleCol.appendChild(el);
          }
        }
        if (needIcon && title && !row.querySelector('.batida-perso-info, .view_product')) {
          // Own class (NOT .batida-perso-info) so custom.js's delegated popup
          // handler never fires on it and clobbers our modal. Markup + colour
          // exactly match the standard INFO_SVG (custom.js) so it's visually
          // identical to the other add-on icons: filled glyph, cocoa #5a4a3e.
          var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          icon.setAttribute('class', 'batida-autofill-info');
          icon.setAttribute('viewBox', '0 0 24 24');
          icon.setAttribute('fill', 'currentColor');
          icon.setAttribute('width', '14');
          icon.setAttribute('height', '14');
          icon.style.cssText = 'cursor:pointer;color:#5a4a3e;opacity:.45;vertical-align:middle;margin-left:5px;flex:0 0 auto;';
          /* 29.09: Batida's 'info' icon (snippets/batida-icons-js.liquid) when the set is loaded; the old glyph is the fallback */
          var biInfo = window.batidaIcons && window.batidaIcons.info;
          if (biInfo) { icon.setAttribute('class', 'batida-autofill-info bi bi--info'); icon.innerHTML = biInfo.replace(/^<svg[^>]*>/, '').replace(/<\/svg>$/, ''); }
          else icon.innerHTML = '<path d="M12.75 11c0-.41-.34-.75-.75-.75s-.75.34-.75.75v6c0 .41.34.75.75.75s.75-.34.75-.75z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25c-5.94 0-10.75 4.81-10.75 10.75s4.81 10.75 10.75 10.75 10.75-4.81 10.75-10.75S17.94 1.25 12 1.25zm-9.25 10.75c0-5.11 4.14-9.25 9.25-9.25s9.25 4.14 9.25 9.25-4.14 9.25-9.25 9.25-9.25-4.14-9.25-9.25z"/><circle cx="12" cy="8" r="1"/>';
          title.appendChild(document.createTextNode(' '));
          title.appendChild(icon);
          icon.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
            var priceText = priceCol ? priceCol.textContent.trim() : '';
            fetchProduct(handle).then(function (pp) { if (pp) openPopup(pp, priceText, shortDescriptor(handle, pp)); });
          }, true);
        }
      }).catch(function () {});
    });
  }

  function boot() {
    enrich();
    try {
      var mo = new MutationObserver(function () { enrich(); });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 8000);
    } catch (e) {}
    [600, 1500, 3000].forEach(function (ms) { setTimeout(enrich, ms); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
